<template>
  <div class="c-share">
    <button
      @click="openShare('facebook')"
      data-sharer="facebook"
      data-hashtag="hashtag"
      :data-title="shareTitle"
      :data-url="localUrl"
    >
      <img src="/src/assets/share/blackfacebook.png">
    </button>
    <button
      @click="openShare('twitter')"
      data-sharer="twitter"
      data-hashtag="hashtag"
      :data-via="originApp"
      :data-title="shareTitle"
      :data-url="localUrl"
    >
      <img src="/src/assets/share/twiter.svg">
    </button>
    <button
      @click="openShare('sina')"
      data-sharer="weibo"
      :data-title="`【（分享来自 @人民日报英文客户端 ）]${shareTitle}`"
      :data-image="sharePicture"
      :data-url="localUrl"
    >
      <img src="/src/assets/share/blackweibo.png">
    </button>
  </div>
</template>

<script setup lang="ts">
import { useStore } from '@gx-vuex'
import { typeViteEnv } from '@/utils/env'

const shareTitle = ref('')
const sharePicture = ref('')
const store = useStore()

const originApp = ref(typeViteEnv('VITE_BASE_APP_ORIGIN'))
const objectType = document.querySelector('body').getAttribute('data-objectType')

const localUrl = ref(location.href)

const openShare = (type: string) => {
  store.point.shareClick(type, Number(objectType))
}

onMounted(() => {
  try {
    // @ts-ignore
    shareTitle.value = shareInfo?.shareTitle
    // @ts-ignore
    sharePicture.value = shareInfo?.fullUrl || ''
  } catch (e) {}
  
  // @ts-ignore
  window.Sharer && window.Sharer?.init()
})
</script>

<style lang="less" scoped>
.c-share {
  display: flex;
  gap: 18px;
  
  button {
    width: 32px;
    height: 32px;
    background: transparent;
    border: 0;
    padding: 0;
    cursor: pointer;
    border-radius: 50%;
    
    img {
      width: 32px;
      height: 32px;
    }
  }
}

</style>
